import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";
import { SITE } from "@/lib/site";
import { QUESTIONS, computeResult } from "@/lib/quiz";
import QuizIntro from "@/components/quiz/QuizIntro";
import QuizQuestion from "@/components/quiz/QuizQuestion";
import QuizResult from "@/components/quiz/QuizResult";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const QuizPage = () => {
  const [step, setStep] = useState(-1); // -1 intro, 0..n-1 questions, n result
  const [answers, setAnswers] = useState([]);
  const [result, setResult] = useState(null);
  const [resultId, setResultId] = useState(null);

  const finish = async (all) => {
    const r = computeResult(all);
    setResult(r);
    setStep(QUESTIONS.length);
    try {
      const { data } = await axios.post(`${API}/quiz/results`, { ...r, answers: all });
      setResultId(data._id || data.id);
    } catch {
      // never block the participant from seeing their result
    }
  };

  const answer = (i) => {
    const next = [...answers, i];
    setAnswers(next);
    if (next.length === QUESTIONS.length) finish(next);
    else setStep(next.length);
  };

  const restart = () => {
    setStep(-1);
    setAnswers([]);
    setResult(null);
    setResultId(null);
    window.scrollTo({ top: 0 });
  };

  return (
    <div className="min-h-screen bg-background" data-testid="quiz-page">
      <header className="flex items-center justify-between px-6 py-6 md:px-12">
        <Link
          to="/"
          data-testid="quiz-back-home"
          className="group inline-flex items-center gap-2 text-sm font-semibold text-primary"
        >
          <ArrowLeft size={16} className="transition-transform duration-300 group-hover:-translate-x-1" />
          {SITE.company}
        </Link>
        <span className="font-display text-xl italic text-primary">Money Passbook</span>
      </header>

      <main className="mx-auto max-w-3xl px-6 pb-24 pt-8 md:px-12 md:pt-16">
        {step === -1 && <QuizIntro onStart={() => setStep(0)} />}
        {step >= 0 && step < QUESTIONS.length && <QuizQuestion key={step} index={step} onAnswer={answer} />}
        {step === QUESTIONS.length && result && (
          <QuizResult result={result} resultId={resultId} onRestart={restart} />
        )}
      </main>
    </div>
  );
};

export default QuizPage;
